import { useEffect, useState } from 'react';
import { isBrowser } from '../isBrowser';

const BREAKPOINTS_MAP = {
	sm: '(max-width: 576px)',
	md: '(max-width: 768px)',
	lg: '(max-width: 992px)',
	xl: '(max-width: 1200px)',
};

const useMediaQuery = (requestedMediaQuery: 'md' | 'sm' | 'lg' | 'xl') => {
	const [isDeviceMatchQuery, setIsDeviceMatchQuery] = useState(false);

	useEffect(() => {
		let mediaQuery: MediaQueryList;
		const deviceHandler = (e) => setIsDeviceMatchQuery(e.matches);
		if (isBrowser()) {
			mediaQuery = window.matchMedia(BREAKPOINTS_MAP[requestedMediaQuery]);
			setIsDeviceMatchQuery(mediaQuery.matches);
			mediaQuery.addEventListener('change', deviceHandler);
		}

		return () => {
			mediaQuery.removeEventListener('change', deviceHandler);
		};
	}, []);

	return isDeviceMatchQuery;
};

export default useMediaQuery;
